import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "table-cell flex selection"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "table-cell gutter" }, "+", -1)
const _hoisted_3 = ["data-row"]
const _hoisted_4 = ["data-row"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_check_box = _resolveComponent("check-box")!

  return (_openBlock(), _createElementBlock("div", {
    class: "table",
    tabindex: "0",
    onKeydown: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onKeydown && _ctx.onKeydown(...args))),
    style: _normalizeStyle({"--table-cell-height":`${_ctx.cellHeight}px`})
  }, [
    _createElementVNode("div", {
      class: "table-column-wrapper",
      style: _normalizeStyle({gridTemplateColumns:`${_ctx.columnWidths} ${_ctx.gutterWidth}`})
    }, [
      (_ctx.selection)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_check_box, {
              modelValue: _ctx.isSelectAll,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isSelectAll) = $event)),
                _ctx.headerCheckChange
              ]
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["table-cell", {flex: column.flex}]),
          key: index
        }, _toDisplayString(column.type === 'index' ? _ctx.data.length : column.title), 3))
      }), 128)),
      _hoisted_2
    ], 4),
    _createElementVNode("div", {
      ref: "scrollWrapper",
      style: {"flex":"auto","overflow":"hidden auto","position":"relative"},
      onScroll: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.updateVisibleData && _ctx.updateVisibleData(...args)))
    }, [
      _createElementVNode("div", {
        style: _normalizeStyle([{"position":"absolute","left":"0","right":"0","z-index":"-1"}, {minHeight: `${_ctx.maxScrollHeight}px`}])
      }, null, 4),
      _createElementVNode("div", {
        class: "content-wrapper",
        style: _normalizeStyle([{"display":"grid","position":"sticky","top":"0"}, {gridTemplateColumns: _ctx.columnWidths, paddingRight: _ctx.hasScrollbar ? null : _ctx.gutterWidth}]),
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onTableCellClick && _ctx.onTableCellClick(...args))),
        onPointermove: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onHover && _ctx.onHover(...args))),
        onPointerleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.hoverRow = -1)),
        onTouchend: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.infiniteScrollEmitter && _ctx.infiniteScrollEmitter(...args))),
        onWheel: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.infiniteScrollEmitter && _ctx.infiniteScrollEmitter(...args)))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleData, (row, rowIndex) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: rowIndex }, [
            (_ctx.selection)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["table-cell flex selection", {selected:_ctx.selectedItems[rowIndex + _ctx.offsetIndex], hover:_ctx.hoverRow === rowIndex}]),
                  "data-row": rowIndex
                }, [
                  _createVNode(_component_check_box, {
                    modelValue: _ctx.selectedItems[rowIndex + _ctx.offsetIndex],
                    "onUpdate:modelValue": [($event: any) => ((_ctx.selectedItems[rowIndex + _ctx.offsetIndex]) = $event), ($event: any) => (_ctx.onItemCheckChanged(rowIndex))]
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ], 10, _hoisted_3))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, columnIndex) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["table-cell", {flex:column.flex, selected:_ctx.selectedItems[rowIndex + _ctx.offsetIndex], hover:_ctx.hoverRow === rowIndex}]),
                "data-row": rowIndex,
                key: `${rowIndex}-${columnIndex}`
              }, [
                _renderSlot(_ctx.$slots, column.property, { item: row }, () => [
                  _createTextVNode(_toDisplayString(_ctx.valueGetters[columnIndex](row, rowIndex, column)), 1)
                ])
              ], 10, _hoisted_4))
            }), 128))
          ], 64))
        }), 128))
      ], 36)
    ], 544)
  ], 36))
}